import { FC } from 'react';
import { Typography } from '@mui/material';

import {
    InventorySourceTypeGroup as DspInventorySourceTypeGroup,
    InventorySource as DspInventorySource,
} from '../../../../../types/Inventory';
import DspInventorySourceUtils from '../../../../../utils/DspInventorySourceUtils';

interface CampaignAdGroupInventorySummaryTextProps {
    items: DspInventorySource[];
}

const CampaignAdGroupInventorySummaryText: FC<CampaignAdGroupInventorySummaryTextProps> = ({ items }) => {
    const groups: DspInventorySourceTypeGroup[] = DspInventorySourceUtils.toDspInventorySourceTypeGroups(items);

    const groupCount: number = groups.length;
    const itemCount: number = items.length;

    return (
        <Typography variant="subtitle2">
            <Typography component="span" variant="subtitle2" color="text.primary">
                {groupCount}
            </Typography>{' '}
            Inventory Sources and{' '}
            <Typography component="span" variant="subtitle2" color="text.primary">
                {itemCount}
            </Typography>{' '}
            Inventory Supplies
        </Typography>
    );
};

export default CampaignAdGroupInventorySummaryText;
